// @ts-nocheck
/**
 * Sidebar flyout components:
 * - CreateFlyout: multi-column create menu
 * - FlyoutPanel: generic side panel wrapper
 * - AllAppsFlyout: expandable apps panel
 * - HoverPreviewCard: hover tooltip for pinned apps
 * - MobileDrawer: full dark mobile side drawer
 * Extracted from the original Sidebar.js.
 */
import React, { useState } from 'react';
import { X, ChevronRight, ChevronDown, Gem, LogOut } from 'lucide-react';
import { useRole } from '../../context/RoleContext';
import {
  ACCENT, FONT, DEFAULT, MUTED, SLIDE_IN,
  ALL_APPS, APP_GROUPS, CREATE_COLUMNS,
  isAppVisibleForRole, isCreateItemVisibleForRole,
} from './constants';

const FLY_CIRCLE_BG = '#1E293B';

export function FlyServiceIcon({ id, color }) {
  const c = color || '#fff';
  switch (id) {
    case 'expenses':
      return (<svg viewBox="0 0 24 24" width={19} height={19}><path fill={c} d="M6 2h12v20l-3-2-3 2-3-2-3 2z"/><rect x="8" y="6" width="8" height="1.6" fill={FLY_CIRCLE_BG}/><rect x="8" y="10" width="8" height="1.6" fill={FLY_CIRCLE_BG}/><rect x="8" y="14" width="5" height="1.6" fill={FLY_CIRCLE_BG}/></svg>);
    case 'accounting':
      return (<svg viewBox="0 0 24 24" width={19} height={19}><path fill={c} d="M3 3h8v8H3V3zm10 0h8v8h-8V3zM3 13h8v8H3v-8zm10 0h8v8h-8v-8z"/></svg>);
    case 'sales':
      return (<svg viewBox="0 0 24 24" width={19} height={19}><rect x="4" y="19.5" width="16" height="1.8" fill={c}/><rect x="6" y="13" width="3" height="7" fill={c}/><rect x="11" y="9" width="3" height="11" fill={c}/><rect x="16" y="5" width="3" height="15" fill={c}/></svg>);
    case 'customer':
      return (<svg viewBox="0 0 24 24" width={19} height={19}><circle cx="12" cy="9" r="3.5" fill={c}/><path fill={c} d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6v1H5z"/><path fill={c} d="M17 3h3a1 1 0 011 1v3a1 1 0 01-1 1h-2l-2 2V3z"/></svg>);
    case 'payroll':
      return (<svg viewBox="0 0 24 24" width={19} height={19}><circle cx="12" cy="12" r="9" fill={c}/><circle cx="12" cy="12" r="5.5" fill={FLY_CIRCLE_BG}/><circle cx="12" cy="12" r="2.5" fill={c}/></svg>);
    case 'team':
      return (<svg viewBox="0 0 24 24" width={19} height={19}><circle cx="8" cy="8" r="3" fill={c}/><circle cx="16" cy="8" r="3" fill={c}/><path fill={c} d="M2 20c0-3 2.5-5 6-5s6 2 6 5v1H2z"/><path fill={c} d="M14 20c0-3 2-5 4-5s4 2 4 5v1h-8z"/></svg>);
    case 'tax':
      return (<svg viewBox="0 0 24 24" width={19} height={19}><circle cx="12" cy="12" r="9" fill={c}/><line x1="8" y1="16" x2="16" y2="8" stroke={FLY_CIRCLE_BG} strokeWidth={2} strokeLinecap="round"/><circle cx="9" cy="9" r="1.5" fill={FLY_CIRCLE_BG}/><circle cx="15" cy="15" r="1.5" fill={FLY_CIRCLE_BG}/></svg>);
    case 'marketing':
      return (<svg viewBox="0 0 24 24" width={19} height={19}><path fill={c} d="M12 2l2.5 7h7l-5.7 4.3 2.2 6.7-6-4.4-6 4.4 2.2-6.7-5.7-4.3h7z"/></svg>);
    case 'hr':
      return (<svg viewBox="0 0 24 24" width={19} height={19}><circle cx="10" cy="8" r="4" fill={c}/><path fill={c} d="M3 21c0-4 3-7 7-7s7 3 7 7v1H3z"/><circle cx="18" cy="17" r="4" fill={c}/><polyline points="16 17 17.5 18.5 20 16" stroke={FLY_CIRCLE_BG} strokeWidth={2.5} fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>);
    default:
      return null;
  }
}


export function CreateFlyout({ onClose, onNavigate, flyoutId, onPanelEnter, onPanelLeave }) {
  const { role: userRole } = useRole();
  return (
    <div
      onMouseEnter={function() { onPanelEnter(flyoutId); }}
      onMouseLeave={function() { onPanelLeave(flyoutId); }}
      style={{ position:'fixed', top:14, left:110, height:'calc(100vh - 28px)', width:780, background:'#fff', boxShadow:'4px 0 32px rgba(0,0,0,0.12)', zIndex:100, display:'flex', flexDirection:'column', animation:'slideIn 0.2s ease', borderRight:'1px solid #F1F5F9' }}
    >
      <style>{SLIDE_IN}</style>
      <div style={{ padding:'16px 24px 12px', borderBottom:'1px solid #F1F5F9', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div style={{ fontSize:15, fontWeight:700, color:'#0F172A' }}>Create</div>
        <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', color:MUTED, display:'flex', alignItems:'center' }}><X size={18}/></button>
      </div>
      <div style={{ flex:1, overflowY:'auto', padding:'20px 24px', display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:20 }}>
        {CREATE_COLUMNS.filter(function(col) { return col.items.some(function(item) { return isCreateItemVisibleForRole(item.path, userRole); }); }).map(function(col) {
          return (
            <div key={col.header}>
              <div style={{ fontSize:14, fontWeight:800, color:'#0E1A1A', marginBottom:14, paddingBottom:8, borderBottom:'1px solid #F1F5F9' }}>{col.header}</div>
              {col.items.filter(function(item) { return isCreateItemVisibleForRole(item.path, userRole); }).map(function(item) {
                return (
                  <div
                    key={item.label}
                    onClick={function() {
                      if (item.isChat) { onClose(); return; }
                      onNavigate(item.path);
                      onClose();
                    }}
                    style={{ padding:'8px', borderRadius:6, cursor:'pointer', fontSize:13, color:'#0E1A1A', fontWeight:500, lineHeight:1.4, transition:'all 0.12s', display:'flex', alignItems:'center', gap:6, minHeight:36 }}
                    onMouseEnter={function(e) { e.currentTarget.style.background='#F1F5F9'; }}
                    onMouseLeave={function(e) { e.currentTarget.style.background='transparent'; }}
                  >
                    <span style={{ flex:1 }}>{item.label}</span>
                    {item.premium && <Gem size={12} color={ACCENT}/>}
                    {item.isChat && <div style={{ width:6, height:6, borderRadius:'50%', background:'#00D4A4', flexShrink:0 }}/>}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function FlyoutPanel({ title, onClose, children, width, flyoutId, onPanelEnter, onPanelLeave, headerAction, compact, anchorTop, anchorBottom, capHeight }) {
  const w = width || 280;
  if (compact) {
    // Compact popup: no header, hugs content, anchored near sidebar button
    const posStyle = (typeof anchorBottom === 'number')
      ? { bottom: anchorBottom }
      : { top: (typeof anchorTop === 'number' ? anchorTop : 120) };
    return (
      <div
        onMouseEnter={function() { if (onPanelEnter) onPanelEnter(flyoutId); }}
        onMouseLeave={function() { if (onPanelLeave) onPanelLeave(flyoutId); }}
        style={Object.assign({ position:'fixed', left:110, width:220, maxHeight:'calc(100vh - 28px)', background:'#fff', border:'1px solid #E7EAF0', borderRadius:10, boxShadow:'0 10px 30px rgba(14,26,26,0.15)', zIndex:100, padding:'6px 0', animation:'slideIn 0.15s ease', overflowY:'auto', scrollbarWidth:'none' }, posStyle)}
      >
        <style>{SLIDE_IN}</style>
        {children}
      </div>
    );
  }
  // Non-compact: anchorTop lets caller anchor the panel to the triggering button;
  // capHeight caps panel height (overrides default max). Auto-flips upward if it would overflow.
  // When anchorTop is given (panel anchors to a specific button), default cap to 420 so
  // the panel can actually sit next to its button; otherwise the big default would always
  // trigger the overflow-flip and pin the panel to the top of the viewport (the "header" bug).
  const cap = (typeof capHeight === 'number')
    ? capHeight
    : (typeof anchorTop === 'number'
      ? 420
      : (typeof window !== 'undefined' ? window.innerHeight - 28 : 600));
  const viewportH = typeof window !== 'undefined' ? window.innerHeight : 800;
  let topVal = (typeof anchorTop === 'number') ? Math.max(14, anchorTop) : 14;
  if (topVal + cap > viewportH - 80) {
    topVal = Math.max(14, viewportH - cap - 80);
  }
  return (
    <div
      onMouseEnter={function() { if (onPanelEnter) onPanelEnter(flyoutId); }}
      onMouseLeave={function() { if (onPanelLeave) onPanelLeave(flyoutId); }}
      style={{ position:'fixed', top:topVal, left:110, maxHeight:cap, width:w, background:'#fff', borderRadius:10, border:'1px solid #E7EAF0', boxShadow:'0 10px 30px rgba(14,26,26,0.15)', zIndex:100, display:'flex', flexDirection:'column', animation:'slideIn 0.2s ease' }}
    >
      <style>{SLIDE_IN}</style>
      <div style={{ padding:'14px 18px 10px', borderBottom:'1px solid #F1F5F9', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
        <div style={{ fontSize:14, fontWeight:700, color:'#0F172A' }}>{title}</div>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          {headerAction}
          <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', color:MUTED, display:'flex', alignItems:'center' }}><X size={16}/></button>
        </div>
      </div>
      <div style={{ overflowY:'auto', scrollbarWidth:'none' }}>{children}</div>
    </div>
  );
}

export function AllAppsFlyout({ onClose, onNavigate, expandedId, location, flyoutId, onPanelEnter, onPanelLeave, pinned, onCategoryHover, onCategoryLeave }) {
  const [expanded, setExpanded] = useState(expandedId || 'accounting');
  const { role: userRole } = useRole();
  return (
    <FlyoutPanel title={<span>All Apps{pinned && <span style={{color:'#0F6E56', fontSize:10, marginLeft:8, fontWeight:600}}>● pinned</span>}</span>} onClose={onClose} width={300} flyoutId={flyoutId} onPanelEnter={onPanelEnter} onPanelLeave={onPanelLeave}>
      <div style={{ padding:'8px 12px' }}>
        {ALL_APPS.filter(function(app) { return isAppVisibleForRole(app.id, userRole); }).map(function(app) {
          const isExpanded = expanded === app.id;
          const Icon = app.icon;
          return (
            <div key={app.id} style={{ marginBottom:2 }}>
              <div
                onClick={function() { if (app.id === 'marketing') { onNavigate(app.items && app.items[0] ? app.items[0].path : '/marketing'); onClose(); return; } if (!pinned) { onNavigate(app.items && app.items[0] ? app.items[0].path : '/'); onClose(); return; } setExpanded(isExpanded ? null : app.id); }}
                style={{ display:'flex', alignItems:'center', gap:10, padding:'10px', borderRadius:8, cursor:'pointer', background:isExpanded?app.color+'10':'transparent', transition:'all 0.15s' }}
                onMouseEnter={function(e) { if (!isExpanded) e.currentTarget.style.background='#F1F5F9'; if (!pinned && app.id !== 'marketing' && onCategoryHover) onCategoryHover(app.id, e.currentTarget.getBoundingClientRect().top); }}
                onMouseLeave={function(e) { if (!isExpanded) e.currentTarget.style.background='transparent'; if (!pinned && onCategoryLeave) onCategoryLeave(); }}
              >
                <div style={{ width:30, height:30, borderRadius:'50%', background:'#1E293B', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  <FlyServiceIcon id={app.id} color={app.color}/>
                </div>
                <span style={{ fontSize:13, fontWeight:isExpanded?600:500, color:isExpanded?app.color:DEFAULT, flex:1 }}>{app.label}</span>
                {app.premium && <span style={{ fontSize:9, color:'#F97316', background:'rgba(249,115,22,0.1)', padding:'1px 5px', borderRadius:4, marginRight:4 }}>PRO</span>}
                {app.id === 'marketing' ? <span style={{color:'#94A3B8', fontSize:11}}>◆</span> : (isExpanded ? <ChevronDown size={13} color={app.color}/> : <ChevronRight size={13} color="#CBD5E1"/>)}
              </div>
              {isExpanded && pinned && (
                <div style={{ paddingLeft:12, marginBottom:4 }}>
                  {app.items.map(function(item, idx) {
                    const isActive = location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path));
                    return (
                      <div
                        key={item.label}
                        onClick={function() { onNavigate(item.path); onClose(); }}
                        style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 12px', borderRadius:6, cursor:'pointer', fontSize:13, fontWeight:isActive?700:500, color:isActive?ACCENT:DEFAULT, background:isActive?'rgba(21,160,140,0.06)':'transparent', transition:'all 0.12s', marginBottom:1 }}
                        onMouseEnter={function(e) { if (!isActive) { e.currentTarget.style.background='#F1F5F9'; e.currentTarget.style.color=ACCENT; } }}
                        onMouseLeave={function(e) { if (!isActive) { e.currentTarget.style.background='transparent'; e.currentTarget.style.color=DEFAULT; } }}
                      >
                        {isActive && <div style={{ width:4, height:4, borderRadius:'50%', background:ACCENT, flexShrink:0 }}/>}
                        {item.label}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </FlyoutPanel>
  );
}

export function HoverPreviewCard({ app, anchorTop, onNavigate, onMouseEnter, onMouseLeave }) {
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ position:'fixed', top:Math.max(16,anchorTop-20), left:118, width:220, background:'#fff', borderRadius:10, boxShadow:'0 8px 32px rgba(0,0,0,0.18)', zIndex:60, padding:'12px 0', border:'1px solid #F1F5F9', animation:'slideIn 0.15s ease' }}
    >
      <style>{SLIDE_IN}</style>
      <div style={{ fontSize:10, fontWeight:800, color:'#0E1A1A', letterSpacing:'0.14em', textTransform:'uppercase', padding:'0 14px 8px', borderBottom:'1px solid #F8FAFC', marginBottom:4 }}>
        {app.label}
      </div>
      {app.items.map(function(item, idx) {
        return (
          <div
            key={item.label}
            onClick={function() { onNavigate(item.path); }}
            style={{ padding:'8px 14px', fontSize:13, fontWeight:idx===0?700:500, color:DEFAULT, cursor:'pointer', transition:'all 0.1s' }}
            onMouseEnter={function(e) { e.currentTarget.style.background='#F8FAFC'; e.currentTarget.style.color=ACCENT; }}
            onMouseLeave={function(e) { e.currentTarget.style.background='transparent'; e.currentTarget.style.color=DEFAULT; }}
          >
            {item.label}
          </div>
        );
      })}
    </div>
  );
}


export function AppSubPanel({ app, onNavigate, onClose, onMouseEnter, onMouseLeave, anchorTop, anchorLeft }) {
  if (!app || !app.items) return null;
  const left = (typeof anchorLeft === 'number') ? anchorLeft : 420;
  // Estimate panel height so we can flip it upward if it would overflow the viewport bottom.
  const itemCount = (app.items || []).length;
  const estHeight = (itemCount * 34) + 12;
  const viewportH = typeof window !== 'undefined' ? window.innerHeight : 800;
  let top = (typeof anchorTop === 'number') ? Math.max(14, anchorTop - 6) : 14;
  if (top + estHeight > viewportH - 80) {
    top = Math.max(14, viewportH - estHeight - 80);
  }
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ position:'fixed', top:top, left:left, width:200, maxHeight:'calc(100vh - 28px)', background:'#fff', border:'1px solid #E7EAF0', borderRadius:10, boxShadow:'0 10px 30px rgba(14,26,26,0.15)', zIndex:101, padding:'6px 0', animation:'slideIn 0.15s ease', overflowY:'auto', scrollbarWidth:'none' }}
    >
      <style>{SLIDE_IN}</style>
      {app.items.map(function(item) {
        return (
          <div
            key={item.label}
            onClick={function() { onNavigate(item.path); onClose(); }}
            style={{ padding:'8px 14px', fontSize:13, fontWeight:500, color:'#0F172A', cursor:'pointer', transition:'all 0.12s' }}
            onMouseEnter={function(e) { e.currentTarget.style.background='#F7F8FA'; }}
            onMouseLeave={function(e) { e.currentTarget.style.background='transparent'; }}
          >
            {item.label}
          </div>
        );
      })}
    </div>
  );
}

export function MobileDrawer({ mobileOpen, onMobileClose, location, onLogout, onNavigate }) {
  return (
    <div style={{ position:'fixed', top:0, left:0, width:300, height:'100vh', background:'linear-gradient(180deg,#0F1A2E 0%,#0D1526 100%)', zIndex:50, transform:mobileOpen?'translateX(0)':'translateX(-100%)', transition:'transform 0.28s cubic-bezier(0.4,0,0.2,1)', display:'flex', flexDirection:'column', fontFamily:FONT, boxShadow:'4px 0 32px rgba(0,0,0,0.4)' }}>
      <div style={{ padding:'18px 20px 14px', borderBottom:'1px solid rgba(255,255,255,0.06)', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
        <div style={{ fontSize:18, fontWeight:800, color:'#F1F5F9', letterSpacing:'-0.02em' }}>
          <img src="/logo-full-green.svg" alt="Novala" style={{ height: 32, width: "auto", objectFit: "contain", verticalAlign: "middle" }} />
        </div>
        <button onClick={onMobileClose} style={{ background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:8, cursor:'pointer', color:'#94A3B8', display:'flex', alignItems:'center', justifyContent:'center', width:34, height:34, flexShrink:0 }}><X size={18}/></button>
      </div>
      <nav style={{ flex:1, overflowY:'auto', padding:'8px 12px', scrollbarWidth:'none' }}>
        {APP_GROUPS.map(function(group) {
          return (
            <div key={group.label} style={{ marginBottom:4 }}>
              <div style={{ fontSize:10, fontWeight:800, color:'#CBD5E1', letterSpacing:'0.16em', textTransform:'uppercase', padding:'14px 10px 6px' }}>{group.label}</div>
              {group.items.map(function(item) {
                const Icon     = item.icon;
                const isActive = location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path));
                return (
                  <div
                    key={item.path}
                    onClick={function() { onNavigate(item.path); }}
                    style={{ display:'flex', alignItems:'center', gap:14, padding:'10px 12px', borderRadius:10, cursor:'pointer', marginBottom:1, background:isActive?'rgba(21,160,140,0.12)':'transparent', borderLeft:'3px solid '+(isActive?ACCENT:'transparent'), transition:'all 0.15s' }}
                    onMouseEnter={function(e) { if (!isActive) e.currentTarget.style.background='rgba(255,255,255,0.04)'; }}
                    onMouseLeave={function(e) { if (!isActive) e.currentTarget.style.background='transparent'; }}
                  >
                    <div style={{ width:32, height:32, borderRadius:8, background:isActive?group.color+'25':'rgba(255,255,255,0.05)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                      <Icon size={16} color={isActive?ACCENT:'#94A3B8'} strokeWidth={2}/>
                    </div>
                    <span style={{ fontSize:14, fontWeight:isActive?700:500, color:'#F1F5F9' }}>{item.label}</span>
                    {isActive && <div style={{ marginLeft:'auto', width:6, height:6, borderRadius:'50%', background:ACCENT, flexShrink:0 }}/>}
                  </div>
                );
              })}
            </div>
          );
        })}
      </nav>
      <div style={{ padding:'12px 16px 32px', borderTop:'1px solid rgba(255,255,255,0.06)', flexShrink:0 }}>
        <button
          onClick={onLogout}
          style={{ width:'100%', padding:'12px', borderRadius:10, background:'transparent', border:'1px solid rgba(255,255,255,0.08)', color:'#64748B', cursor:'pointer', fontSize:14, fontFamily:FONT, display:'flex', alignItems:'center', justifyContent:'center', gap:10, transition:'all 0.15s' }}
          onMouseEnter={function(e) { e.currentTarget.style.background='rgba(239,68,68,0.08)'; e.currentTarget.style.color='#EF4444'; e.currentTarget.style.borderColor='rgba(239,68,68,0.2)'; }}
          onMouseLeave={function(e) { e.currentTarget.style.background='transparent'; e.currentTarget.style.color='#64748B'; e.currentTarget.style.borderColor='rgba(255,255,255,0.08)'; }}
        >
          <LogOut size={16}/> Sign Out
        </button>
      </div>
    </div>
  );
}
